import React from "react";
import { Rocket, BarChart3, Linkedin } from "lucide-react";

export default function LiveShowcase() {
  const cards = [
    {
      icon: Rocket,
      title: "Enter Your Query",
      desc: "Use custom Google operators like site:blog + 'SaaS guest post'.",
    },
    {
      icon: BarChart3,
      title: "Get Enriched Websites",
      desc: "See DA, PA, Spam Score & contextual titles instantly.",
    },
    {
      icon: Linkedin,
      title: "Connect with People",
      desc: "Find real LinkedIn profiles of editors and SEO managers.",
    },
  ];

  return (
    <section id="showcase" className="bg-gray-50 py-20 px-6 text-center">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-12">
          How Backlink Banana{" "}
          <span className="bg-gradient-to-r from-green-500 to-blue-600 bg-clip-text text-transparent">
            Works in 3 Steps
          </span>
        </h2>

        <div className="grid sm:grid-cols-3 gap-10">
          {cards.map((c) => (
            <div
              key={c.title}
              className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-xl transition-all duration-300"
            >
              <c.icon className="w-10 h-10 text-green-600 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {c.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
